import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Toolbar,
  Tooltip,
  Typography
} from '@mui/material';

import TextField from '@mui/material/TextField';
import Logo from 'src/minimal-components/logo';
import AccountPopover from 'src/layouts/common/account-popover';
import {useLocation, useNavigate} from 'react-router-dom';
import FormConstants from '@shared/constants/FormConstants';
import React, {useEffect, useState} from 'react';
import {
  LMS_TYPE,
  BASE_RECORD_ID,
  BASE_UNIQUE_ID,
  LMS_MODULE_ID,
  LMS_PREVIEW_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  PARAMS_KEY,
  MOVE_TO_TAB,
  LMS_IS_ADMIN,
  BASE_UNIQUE_TYPE
} from 'src/routes/BaseRoute';
import EncryptUtils from 'src/utils/EncryptUtils';
import {CloseIcon} from 'yet-another-react-lightbox';
import {
  getLMSResultsData,
  getSearchForm
} from '@shared/services/service-handlers/PrivateService';
import {useAppContext} from '@context/AppContext';
import {enqueueSnackbar} from '@components/snackbar';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import MatchTheFollowingQuestion from './MatchPairs';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import { environment } from '@shared/config/environment';

const ScorePreviewPage = () => {
  const {
    appState: {applicationName}
  } = useAppContext();
  const location = useLocation();
  const {fieldsData} = location.state || {};

  const navigate = useNavigate();
  function useQuery() {
    const {search} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const [fieldsDatavals, setFieldsData] = React.useState<any>();
  const [uiFieldsvals, setUiFields] = React.useState();
  const [isLoaded, setIsLoaded] = React.useState(true);
  const [isloading, setIsloading] = React.useState(false);
  const [selectedOptions, setSelectedOptions] = useState<
    Array<{
      id: number;
      questionId: number;
      answered: boolean;
      score: number;
      answers:
        | string[]
        | string
        | boolean
        | {left: string; right: string}[]
        | any;
    }>
  >([]);
  const [isChecked, setChecked] = useState(false);
  //console.log('fieldsDatavals', selectedOptions, fieldsDatavals);
  const query = useQuery();
  const lmstype = EncryptUtils.getDecryptedData(location?.search, LMS_TYPE);
  const section = query.get('section');
  const subSection = query.get('subsection');
  const lmsisAdmin = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_IS_ADMIN
  );
  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const fileId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_ID
  );
    const filetype=EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_TYPE
  );
  const moduleId = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_MODULE_ID
  );
  const previewId = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_PREVIEW_ID
  );
  const subModuleName = EncryptUtils.getDecryptedData(
    location?.search,
    MOVE_TO_TAB
  );
  //console.log('previewId', previewId, fileId, moduleId, uniqueId);
  // console.log('fieldsData', fieldsData);
  const handleClose = async () => {
    if (subModuleName !== 'ModuleMain') {
      const paramsKey = EncryptUtils.setEncryptedParams({
        [BASE_RECORD_ID]: uniqueId,
        [LMS_TYPE]: lmstype,
        [BASE_UNIQUE_ID]: fileId,
        [LMS_MODULE_ID]: moduleId,
        [LMS_IS_ADMIN]: lmsisAdmin
      });
      navigate(
        `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/new?${PARAMS_KEY}=${paramsKey}&section=Pre_post_learning&subsection=pre_learning_activities`,
        {
          state: {}
        }
      );
    } else {
      // console.log('onRoleChange1', fileId, moduleId);
      const paramsKey = EncryptUtils.setEncryptedParams({
        [BASE_RECORD_ID]: uniqueId,
        [LMS_TYPE]: lmstype,
        [BASE_UNIQUE_ID]: fileId,
        [BASE_UNIQUE_TYPE]:filetype,
        [LMS_MODULE_ID]: moduleId,
        [LMS_PREVIEW_ID]: previewId,
        [MOVE_TO_TAB]: subModuleName,
        [LMS_IS_ADMIN]: lmsisAdmin
      });
      navigate(
        `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/Preview?${PARAMS_KEY}=${paramsKey}`,
        {
          state: {}
        }
      );
    }
  };
  const init = async () => {
    try {
      setIsloading(true);
      const res = await getSearchForm(
        applicationName,
        'module',
        'PreviewScore'
      );
      setUiFields(res.searchForm);
      if (res.searchForm) {
        let sqlName;
        const operations = 'SEARCH';
        let TableName;
        let TableQuestions;
        switch (subModuleName) {
          case 'pre_learning_activities':
            (TableName = 'SettingsPreLearningTestList'),
              (TableQuestions = 'SettingsPreLearningQuestionsStorage');
            sqlName = 'PreLearning_sql';
            break;
          case 'post_learning_activities':
            (TableName = 'SettingsPostLearningTestList'),
              (TableQuestions = 'SettingsPostLearningQuestionsStorage');
            sqlName = 'PostLearning_sql';
            break;
          case 'prepost_feedback':
            (TableName = 'SettingsPreLearningTestList'),
              (TableQuestions = 'SettingsPreLearningQuestionsStorage');
            break;
          case 'ModuleMain':
            (TableName = 'ModuleOnlineTestList'),
              (TableQuestions = 'ModuleQuestionsStorage');
            sqlName = 'Module_sql';
            break;
          default:
            (TableName = 'ModuleOnlineTestList'),
              (TableQuestions = 'ModuleQuestionsStorage');
            sqlName = 'Module_sql';
            break;
        }
        if (sqlName) {
          const {sqldata} = res.searchForm[sqlName];
          const data: any = {
            sql_data: sqldata,
            data: {
              id: previewId,
              course_overview_id: uniqueId,
              testId: fileId,
              isAdmin: lmsisAdmin === 'True'
            },
            operation: operations
          };
          const encryptRequestData = EncryptUtils.encryptedData(data);
          const result = await getLMSResultsData(applicationName, 'LMS', {
            tk: encryptRequestData
          });
          //console.log('result', result);
          if (result.data[0]) {
            const transformedResult = result.data.map((item: any) => {
              return {
                ...item,
                // Parse JSON fields or set them to empty arrays if they are null
                choices: item.choices ? JSON.parse(item.choices) : null,
                correctMatches: item.correctMatches
                  ? JSON.parse(item.correctMatches)
                  : null,
                additionalChoices: item.additionalChoices
                  ? JSON.parse(item.additionalChoices)
                  : null,
                CorrectAnswers: item.CorrectAnswers
                  ? JSON.parse(item.CorrectAnswers)
                  : null,
                descriptive_enforce_word_limit:
                  item.descriptive_enforce_word_limit
                    ? JSON.parse(item.descriptive_enforce_word_limit)
                        .descriptive_enforce_word_limit
                    : null,
                // Parse the descriptive_enforce_word_limit_length JSON or set it to null
                descriptive_enforce_word_limit_length:
                  item.descriptive_enforce_word_limit_length
                    ? JSON.parse(item.descriptive_enforce_word_limit_length)
                        .descriptive_enforce_word_limit_length
                    : null,
                TrueFalse: item.TrueFalse
                  ? JSON.parse(item.TrueFalse).TrueFalse
                  : null
                // Add any additional transformations here if needed
              };
            });
            // console.log(
            //   'transformedResult[0]',
            //   transformedResult[0],
            //   transformedResult[0].AnsweredValue
            // );
            setFieldsData(transformedResult[0]);
            setSelectedOptions(transformedResult[0].AnsweredValue);
          }
        }
        setIsloading(false);
      }
      setIsloading(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      setIsloading(false);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };
  useEffect(() => {
    // console.log(
    //   'selectedPreviewFile',
    //   fieldsData
    //   // mainContent
    // );
    const fetchData = async () => {
      try {
        //console.log('uniqueId', uniqueId, moduleId, fileId);
        // const res = await getSearchForm(applicationName, 'module');
        // setUiFields(res.searchForm);
        await init();
      } catch (error) {
        console.error('error', error);
      }
    };
    //console.log('selectedPreviewFile', fieldsData);
    fetchData();
  }, []);
  useEffect(() => {
    // 🔥 Prevent back button navigation
    const handleBackButton = (event: PopStateEvent): void => {
      // //console.log('event', event);
      event.preventDefault();
      window.history.pushState(null, '', window.location.href);
      navigate(0);
    };

    window.history.pushState(null, '', window.location.href); // Push current page into history

    window.addEventListener('popstate', handleBackButton); // Listen for back button press

    return () => {
      window.removeEventListener('popstate', handleBackButton); // Cleanup listener on unmount
    };
  }, [navigate]);
  const FetchQuestion = (question: any) => {
    switch (question.QuestionType_id) {
      case 1: // Single Option
        return (
          <Box>
            <RadioGroup
              value={
                selectedOptions
                  .find(q => q.questionId === question.id)
                  ?.answers?.toString() || ''
              }
              sx={{mt: 2}}>
              {question.choices.map(
                (option: {id: number; OptionText: string}) => {
                  const selectedAnswer = selectedOptions.find(
                    q => q.questionId === question.id
                  )?.answers;
                  const isChecked =
                    selectedAnswer?.toString() === option.id.toString();

                  return (
                    <FormControlLabel
                      key={option.id}
                      value={option.id.toString()}
                      control={
                        <Radio checked={isChecked} disabled={!isChecked} />
                      }
                      label={option.OptionText}
                    />
                  );
                }
              )}
            </RadioGroup>
            {isChecked && (
              <Box
                sx={{
                  px: 2,
                  py: 1,
                  backgroundColor: 'antiquewhite',
                  borderRadius: '8px'
                }}>
                <Typography sx={{mt: 1}}>Correct Answer is : </Typography>
                <Typography variant={'h6'} sx={{mt: 1}}>
                  {`${question.CorrectAnswers.map((value: {OptionText: any}) => value.OptionText).join(', ')}`}
                </Typography>
              </Box>
            )}
          </Box>
        );

      case 2: // Multiple Choice
        return (
          <Box>
            <FormGroup sx={{mt: 2}}>
              {question.choices.map(
                (option: {id: number; OptionText: string}) => {
                  // Get selected answers ensuring it's an array
                  const selectedAnswers = (selectedOptions.find(
                    q => q.questionId === question.id
                  )?.answers ?? []) as string[];
                  //console.log('selectedAnswers', selectedAnswers);
                  return (
                    <FormControlLabel
                      key={option.id}
                      control={
                        <Checkbox
                          checked={selectedAnswers.includes(
                            option.id.toString()
                          )}
                          disabled={
                            !selectedAnswers.includes(option.id.toString())
                          }
                        />
                      }
                      label={option.OptionText}
                    />
                  );
                }
              )}
            </FormGroup>
            {isChecked && (
              <Box
                sx={{
                  px: 2,
                  py: 1,
                  backgroundColor: 'antiquewhite',
                  borderRadius: '8px'
                }}>
                <Typography sx={{mt: 1}}>Correct Answer is : </Typography>
                <Typography variant={'h6'} sx={{mt: 1}}>
                  {`${question.CorrectAnswers.map((value: {OptionText: any}) => value.OptionText).join(', ')}`}
                </Typography>
              </Box>
            )}
          </Box>
        );

      case 3: // True/False
        return (
          <Box>
            <RadioGroup
              value={
                selectedOptions
                  .find(q => q.questionId === question.id)
                  ?.answers?.toString() || ''
              }
              sx={{mt: 2}}>
              {[
                {id: 1, OptionText: 'True'},
                {id: 0, OptionText: 'False'}
              ].map(option => {
                const selectedAnswer = selectedOptions.find(
                  q => q.questionId === question.id
                )?.answers;
                const isChecked =
                  selectedAnswer?.toString() === option.id.toString();

                return (
                  <FormControlLabel
                    key={option.id}
                    value={option.id.toString()}
                    control={
                      <Radio checked={isChecked} disabled={!isChecked} />
                    }
                    label={option.OptionText}
                  />
                );
              })}
            </RadioGroup>
            {isChecked && (
              <Box
                sx={{
                  px: 2,
                  py: 1,
                  backgroundColor: 'antiquewhite',
                  borderRadius: '8px'
                }}>
                <Typography sx={{mt: 1}}>Correct Answer is : </Typography>
                <Typography variant={'h6'} sx={{mt: 1}}>
                  {`${question.TrueFalse.map((value: {TrueFalse: any}) => (value?.TrueFalse ? 'True' : 'False')).join(', ')}`}
                </Typography>
              </Box>
            )}
          </Box>
        );

      case 4: // Match the Following
        const selectedAnswer = selectedOptions.find(
          q => q.questionId === question.id
        )?.answers;
        if (selectedAnswer === undefined || selectedAnswer === null) {
          return (
            <Box>
              <Grid container sx={{mt: 2}} spacing={2}>
                {/* Left Side (Fixed Questions) */}
                <Grid item xs={4}>
                  {question.correctMatches.map(
                    (pair: {
                      match_the_following_left_value: string | number;
                      match_the_following_right_value: string | number;
                      id: number | string;
                    }) => {
                      //console.log('pair', pair);
                      return (
                        pair?.match_the_following_left_value && (
                          <Paper
                            key={pair.id}
                            sx={{
                              p: 1,
                              mb: 1,
                              textAlign: 'left',
                              backgroundColor: '#f0f0f0'
                            }}>
                            {pair?.match_the_following_left_value}
                          </Paper>
                        )
                      );
                    }
                  )}
                </Grid>
                <Grid item xs={4}>
                  {question.correctMatches.map(
                    (pair: {
                      match_the_following_left_value: string | number;
                      match_the_following_right_value: string | number;
                      id: number | string;
                    }) => {
                      //console.log('pair', pair);
                      return (
                        pair?.match_the_following_left_value && (
                          <Paper
                            key={pair.id}
                            sx={{
                              p: 1,
                              mb: 1,
                              textAlign: 'left',
                              backgroundColor: '#f0f0f0'
                            }}>
                            {pair?.match_the_following_right_value}
                          </Paper>
                        )
                      );
                    }
                  )}
                </Grid>
              </Grid>
              {isChecked && (
                <Box
                  sx={{
                    px: 2,
                    py: 1,
                    backgroundColor: 'antiquewhite',
                    borderRadius: '8px'
                  }}>
                  <Typography sx={{mt: 1}}>Correct Answer is : </Typography>
                  <Grid container sx={{mt: 2}} spacing={2}>
                    {/* Left Side (Fixed Questions) */}
                    <Grid item xs={4}>
                      {question.correctMatches.map(
                        (pair: {
                          match_the_following_left_value: string | number;
                          match_the_following_right_value: string | number;
                          id: number | string;
                        }) => {
                          //console.log('pair', pair);
                          return (
                            pair?.match_the_following_left_value && (
                              <Paper
                                key={pair.id}
                                sx={{
                                  p: 1,
                                  mb: 1,
                                  textAlign: 'left',
                                  backgroundColor: 'white'
                                }}>
                                {pair?.match_the_following_left_value}
                              </Paper>
                            )
                          );
                        }
                      )}
                    </Grid>

                    {/* Left Side (Fixed Questions) */}
                    <Grid item xs={4}>
                      {question.correctMatches.map(
                        (pair: {
                          match_the_following_right_value: string | number;
                          id: number | string;
                        }) => {
                          //console.log('pair', pair);
                          return (
                            <Paper
                              key={pair.id}
                              sx={{
                                p: 1,
                                mb: 1,
                                textAlign: 'left',
                                backgroundColor: 'white'
                              }}>
                              {pair?.match_the_following_right_value}
                            </Paper>
                          );
                        }
                      )}
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Box>
          );
        }
        const value = JSON.parse(selectedAnswer);
        //console.log('value', value);
        return (
          <Box>
            <Grid container sx={{mt: 2}} spacing={2}>
              {/* Left Side (Fixed Questions) */}
              <Grid item xs={4}>
                {value.map(
                  (pair: {
                    left: string | number;
                    right: string | number;
                    id: number | string;
                  }) => {
                    //console.log('pair', pair);
                    return (
                      pair?.left && (
                        <Paper
                          key={pair.id}
                          sx={{
                            p: 1,
                            mb: 1,
                            textAlign: 'left',
                            backgroundColor: '#f0f0f0'
                          }}>
                          {pair?.left}
                        </Paper>
                      )
                    );
                  }
                )}
              </Grid>
              <Grid item xs={4}>
                {value.map(
                  (pair: {
                    left: string | number;
                    right: string | number;
                    id: number | string;
                  }) => {
                    const correctPair = question.correctMatches.find(
                      (cp: {id: string | number}) => cp.id === pair.id
                    );

                    // Check if the selected right value is correct
                    const isCorrect = correctPair
                      ? correctPair.match_the_following_right_value ===
                        pair.right
                      : false;

                    return (
                      pair?.left && (
                        <Paper
                          key={pair.id}
                          sx={{
                            p: 1,
                            mb: 1,
                            textAlign: 'left',
                            backgroundColor: '#f0f0f0'
                          }}>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between'
                            }}>
                            <Typography>{pair?.right} </Typography>
                            <Typography>{isCorrect ? '✅' : '❌'}</Typography>
                          </Box>
                        </Paper>
                      )
                    );
                  }
                )}
              </Grid>
            </Grid>
            {isChecked && (
              <Box
                sx={{
                  px: 2,
                  py: 1,
                  backgroundColor: 'antiquewhite',
                  borderRadius: '8px'
                }}>
                <Typography sx={{mt: 1}}>Correct Answer is : </Typography>
                <Grid container sx={{mt: 2}} spacing={2}>
                  {/* Left Side (Fixed Questions) */}
                  <Grid item xs={4}>
                    {question.correctMatches.map(
                      (pair: {
                        match_the_following_left_value: string | number;
                        match_the_following_right_value: string | number;
                        id: number | string;
                      }) => {
                        //console.log('pair', pair);
                        return (
                          pair?.match_the_following_left_value && (
                            <Paper
                              key={pair.id}
                              sx={{
                                p: 1,
                                mb: 1,
                                textAlign: 'left',
                                backgroundColor: 'white'
                              }}>
                              {pair?.match_the_following_left_value}
                            </Paper>
                          )
                        );
                      }
                    )}
                  </Grid>

                  {/* Left Side (Fixed Questions) */}
                  <Grid item xs={4}>
                    {question.correctMatches.map(
                      (pair: {
                        match_the_following_right_value: string | number;
                        id: number | string;
                      }) => {
                        //console.log('pair', pair);
                        return (
                          <Paper
                            key={pair.id}
                            sx={{
                              p: 1,
                              mb: 1,
                              textAlign: 'left',
                              backgroundColor: 'white'
                            }}>
                            {pair?.match_the_following_right_value}
                          </Paper>
                        );
                      }
                    )}
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>
        );

      case 5:
        if (selectedOptions.find(q => q.questionId === question.id)?.answered) {
          return (
            <TextField
              fullWidth
              multiline
              size="small"
              value={
                selectedOptions
                  .find(q => q.questionId === question.id)
                  ?.answers?.toString() || ''
              }
              InputProps={{
                sx: {
                  typography: 'body2',
                  minHeight: '12vh',
                  alignItems: 'baseline'
                }
              }}
              sx={{minHeight: '12vh'}}
            />
          );
        }
        break;
      default:
        return null;
    }
  };
  const renderContent = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1
      }}>
      <Logo
        disabledLink={true}
        applicationName={'LMS'}
        sx={{mt: 3, ml: 4, mb: 1}}
      />

      <Box>
                {!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED  &&<AccountPopover isDashboard={true} /> }
        <Tooltip title="Close">
          <IconButton onClick={() => handleClose()}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to right, #3a7bd5, #3a6073)',
        color: 'white'
      }}>
      <Toolbar
        sx={{
          height: 1,
          backgroundColor: 'white'
          // px: {lg: 5}
        }}>
        {renderContent}
      </Toolbar>
      {isloading ? (
        <Stack
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          minHeight={'80vh'}>
          <LoadingScreen />
        </Stack>
      ) : (
        <Box sx={{pt: 4}}>
          {/* Header */}
          <Box>
            <Typography
              variant="h5"
              sx={{textAlign: 'center', fontWeight: 'bold', mb: 0.5}}>
              {fieldsDatavals?.name}
            </Typography>
            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{mb: 1, display: 'flex'}}
              justifyContent={'center'}>
              <Grid item sx={{display: 'flex'}}>
                <Typography variant="subtitle2" sx={{mr: 0.5}}>
                  <strong>Date : </strong>
                </Typography>
                <Typography variant="body1">
                  {fieldsDatavals?.TestStartTime
                    ? new Date(fieldsDatavals.TestStartTime).toLocaleDateString(
                        'en-GB',
                        {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        }
                      )
                    : 'N/A'}
                </Typography>
              </Grid>
              {/* Dynamically Render Fields */}
              {[
                {
                  label: 'Total Questions : ',
                  value: fieldsDatavals?.TotalQuestions
                },
                {
                  label: 'Duration : ',
                  value:
                    fieldsDatavals?.TotalTimeInMinutes ||
                    (fieldsDatavals?.overallTime_in_minutes &&
                      `${fieldsDatavals?.TotalTimeInMinutes || fieldsDatavals?.overallTime_in_minutes} Min`)
                },
                {label: 'Total Marks : ', value: fieldsDatavals?.TotalMarks},
                {
                  label: 'Passing Marks : ',
                  value: fieldsDatavals?.pass_percentage
                }
              ]
                .filter(
                  field => field.value !== undefined && field.value !== null
                ) // Ensure only valid fields are shown
                .map((field, index) => (
                  <Grid key={index} item sx={{display: 'flex'}}>
                    <Typography variant="subtitle2" sx={{mr: 0.5}}>
                      <strong>{field.label}</strong>
                    </Typography>
                    <Typography variant="body1">{field.value}</Typography>
                  </Grid>
                ))}

              {/* Action Button */}
            </Grid>
          </Box>
          <Paper
            // elevation={3}
            sx={{
              maxWidth: '90vw',
              display: 'flex',
              margin: '0 auto',
              padding: 3,
              borderRadius: '10px',
              mb: 1
            }}>
            <Card
              sx={{
                backgroundColor: '#f8f9fa',
                marginTop: 3,
                display: 'flex',
                flex: 1,
                boxShadow:
                  '0px 3px 3px -2px rgba(145, 158, 171, 0.2), 0px 3px 4px 0px rgba(145, 158, 171, 0.14), 0px 1px 8px 0px rgba(145, 158, 171, 0.12)',
                borderRadius: '8px'
              }}>
              <CardContent
                sx={{
                  display: 'block',
                  flex: 1
                }}>
                <Typography
                  variant="h5"
                  sx={{textAlign: 'center', fontWeight: 'bold', mb: 0.5}}>
                  Assessment Summary
                </Typography>
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  sx={{mb: 1, display: 'flex'}}
                  justifyContent={'center'}>
                  {/* Dynamically Render Fields */}
                  {[
                    {
                      label: 'Time taken : ',
                      value: fieldsDatavals?.TimeDifference
                    },
                    {
                      label: 'Attended on : ',
                      value: fieldsDatavals?.TestStartTime
                        ? new Date(
                            fieldsDatavals.TestStartTime
                          ).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric'
                          })
                        : 'N/A'
                    },
                    {
                      label: 'Questions attended : ',
                      value: fieldsDatavals?.QuestionsAnswered
                    },
                    {
                      label: 'Questions not attended : ',
                      value: fieldsDatavals?.QuestionsNotAnswered
                    }
                  ]
                    .filter(
                      field => field.value !== undefined && field.value !== null
                    ) // Ensure only valid fields are shown
                    .map((field, index) => (
                      <Grid key={index} item sx={{display: 'flex'}}>
                        <Typography variant="subtitle2" sx={{mr: 0.5}}>
                          <strong>{field.label}</strong>
                        </Typography>
                        <Typography variant="body1">{field.value}</Typography>
                      </Grid>
                    ))}

                  {/* Action Button */}
                </Grid>
              </CardContent>
            </Card>
          </Paper>
          <Box
            // elevation={3}
            sx={{
              maxWidth: '90vw',
              maxHeight: '58vh',
              display: 'grid',
              overflow: 'auto',
              margin: '0 auto',
              padding: 3,
              backgroundColor: 'aliceblue',
              borderRadius: '10px'
            }}>
            <Card
              sx={{
                backgroundColor: '#f8f9fa',
                marginTop: 3,
                display: 'flex',
                flex: 1,
                minHeight: '30vh',
                boxShadow:
                  '0px 3px 3px -2px rgba(145, 158, 171, 0.2), 0px 3px 4px 0px rgba(145, 158, 171, 0.14), 0px 1px 8px 0px rgba(145, 158, 171, 0.12)',
                borderRadius: '8px'
              }}>
              <CardContent
                sx={{
                  display: 'flex',
                  flex: 1
                }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    flex: 1
                  }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-end',
                      alignItems: 'center'
                    }}>
                    <Typography>Test Completed!</Typography>
                    <Typography>{`You have scored ${fieldsDatavals?.Percentage} %  with ${fieldsDatavals?.overAllScore} mark out of ${fieldsDatavals?.TotalMarks}`}</Typography>
                  </Box>
                  {fieldsDatavals?.showCorrectAnswers && (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end'
                      }}>
                      {
                        //checkbox code to display whether to displau the answers
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={() =>
                                setChecked((prev: boolean) => !prev)
                              }
                              value={isChecked}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Show Correct Answer"
                        />
                      }
                    </Box>
                  )}
                </Box>
              </CardContent>
            </Card>
            <Grid
              item
              sx={{display: 'flex', flexDirection: 'column', rowGap: 2, mt: 2}}
              xs={10}
              sm={10}
              md={8}>
              {fieldsDatavals?.files?.map(
                (
                  question: {
                    id: number;
                    QuestionText: string;
                    QuestionType_id: number;
                    choices: any[];
                  },
                  index: number
                ) => {
                  return (
                    <Card key={question.id} sx={{borderRadius: '10px'}}>
                      <CardContent>
                        {/* Question Numbering */}
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'baseline',
                            columnGap: 2
                          }}>
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              width: '100%'
                            }}>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                flex: 1,
                                justifyContent: 'space-between'
                              }}>
                              <Typography
                                variant="h6"
                                sx={{fontSize: 'x-large !important'}}>
                                <strong>{index + 1}</strong> /{' '}
                                {fieldsDatavals?.files.length}
                              </Typography>
                              {
                                //i want to show the question marks scored by the user i want to show in the chip no.of marks scored if correct else 0marks
                                <Chip
                                  label={`${
                                    selectedOptions.find(
                                      q => q.questionId === question.id
                                    )?.answered
                                      ? selectedOptions.find(
                                          q => q.questionId === question.id
                                        )?.score
                                      : 0
                                  } Marks`}
                                  color={
                                    selectedOptions.find(
                                      q => q.questionId === question.id
                                    )?.answered &&
                                    (selectedOptions.find(
                                      q => q.questionId === question.id
                                    )?.score ?? 0) > 0
                                      ? 'success'
                                      : 'error'
                                  }
                                  size="small"
                                  sx={{mt: 1}}
                                />
                              }
                            </Box>
                            {selectedOptions.find(
                              q => q.questionId === question.id
                            )?.answered === false ? (
                              <Box>
                                <Typography
                                  variant="h6"
                                  sx={{mt: 2, fontWeight: '100'}}>
                                  The user did not answer this question.
                                </Typography>
                                <Typography variant="h5" sx={{mt: 1}}>
                                  {question.QuestionText}
                                </Typography>
                              </Box>
                            ) : (
                              <Typography variant="h5" sx={{mt: 1}}>
                                <strong>{question.QuestionText}</strong>
                              </Typography>
                            )}
                          </Box>
                        </Box>
                        <Box sx={{my: 1}}>{FetchQuestion(question)}</Box>
                      </CardContent>
                    </Card>
                  );
                }
              )}
            </Grid>
          </Box>
        </Box>
      )}
    </Box>
  );
};
export default ScorePreviewPage;

